// Экран 1 из ТЗ раздел 3.3: витрина тарифов.
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { ApiError, fetchPlans, type Plan } from "../api/client";

export function PlansScreen() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [plans, setPlans] = useState<Plan[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetchPlans()
      .then((data) => {
        if (!cancelled) setPlans(data);
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        setError(err instanceof ApiError ? err.message : String(err));
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div>
      <h1>{t("plans_title")}</h1>
      {error && <p role="alert">{t("plans_error")}</p>}
      {!error && plans === null && <p>{t("loading")}</p>}
      {plans !== null && plans.length === 0 && <p>{t("plans_empty")}</p>}
      {plans !== null && plans.length > 0 && (
        <ul>
          {plans.map((plan) => (
            <li key={plan.id}>
              <strong>{plan.title}</strong> — {plan.price} {plan.currency} / {plan.duration_days}{" "}
              {t("days_short")}, {t("device_limit", { count: plan.device_limit })}
              {!plan.is_trial && (
                <>
                  {" "}
                  <button type="button" onClick={() => navigate(`/checkout/${plan.id}`)}>
                    {t("buy")}
                  </button>
                </>
              )}
              {plan.is_trial && <> — {t("plans_trial_via_promo")}</>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
